import React from "react";

import styles from "./footerStyles.module.css";
import GatsbyLogo from "../../assets/gatsby-logo.jpg";

const Footer = () => {
  return (
    <div className={styles.footer}>
      <div className={styles.footerContainer}>
        <p>
          Developed & Designed using <a href="https://www.gatsbyjs.com/starters/amandeepmittal/gatsby-portfolio-v3/"> gatsby-portfolio-v3 </a>.
        </p>
      </div>
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js